import { render, staticRenderFns } from "./SVGIcon.vue?vue&type=template&id=09dcbf3c&scoped=true"
import script from "./SVGIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SVGIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SVGIcon.vue?vue&type=style&index=0&id=09dcbf3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dcbf3c",
  null
  
)

export default component.exports